import { EMethods, IState, ISearchQuery } from "store/store.interface";
import {
  CREATE_BULK_BUNDLE_JOB,
  ADD_BULK_BUNDLE_JOB_TO_THE_LIST,
  BULK_BUNDLE_FETCH_JOBS,
  BULK_BUNDLE_SET_JOBS,
  BULK_BUNDLE_UPDATE_JOB_STATUS,
  BULK_BUNDLE_CLEAR_JOB_LIST,
  BULK_BUNDLE_UPDATE_PAGE_NUMBER,
  BULK_BUNDLE_RESOURCE_GET_BY_ID,
} from "../store.types";
import { Dispatch } from "redux";
import {
  apiAction,
  replaceUrlVariables,
} from "store/middlewares/api.middleware.helper";
import { endpoints } from "constant";
import { downloadCSV } from "utils/app.utils";
import { IQuery } from "store/reducers/promotion.reducers";

export const getBulkBundleResource = (id?: string) => (dispatch: Dispatch) => {
  const endPoint = id
    ? replaceUrlVariables(endpoints.GET_BULK_BUNDLE_JOB_BY_ID, { id })
    : endpoints.GET_BULK_UPLOAD_RESOURCE_TEMPLATE;
  const fileName = id ? "bulkBundleActive.csv" : "bulkBundleTemplate.csv";
  dispatch(
    apiAction({
      url: endPoint,
      label: BULK_BUNDLE_RESOURCE_GET_BY_ID,
      method: EMethods.GET,
      withStoreId: true,
      withToken: true,
      isBundlePromotion: true,
      data: {},
      onSuccess: (data) => () => {
        downloadCSV(data, fileName);
      },
    })
  );
};

export const createBulkBundles = (data: FormData) => (dispatch: Dispatch) => {
  dispatch(
    apiAction({
      forFileSend: true,
      url: endpoints.CREATE_BULK_BUNDLES,
      method: EMethods.POST,
      withToken: true,
      withStoreId: true,
      label: CREATE_BULK_BUNDLE_JOB,
      isBundlePromotion: true,
      data: data,
      onSuccess:
        ({ data }) =>
        (dispatch: Dispatch) => {
          dispatch({
            type: ADD_BULK_BUNDLE_JOB_TO_THE_LIST,
            payload: data,
          });
        },
    })
  );
};

export const clearBulkBundleJobList = () => ({
  type: BULK_BUNDLE_CLEAR_JOB_LIST,
});

export const fetchBulkBundleJobs =
  (query?: IQuery) => (dispatch: Dispatch, getState: () => IState) => {
    const {
      config: { limit: defaultLimit },
    } = getState();
    const { page, limit } = query || {};
    if (!page) {
      dispatch(clearBulkBundleJobList());
    }
    let endPoint = endpoints.FETCH_BULK_BUNDLE_JOBS;
    dispatch(
      apiAction({
        url: endPoint,
        method: EMethods.GET,
        label: BULK_BUNDLE_FETCH_JOBS,
        withStoreId: true,
        withToken: true,
        isBundlePromotion: true,
        data: {
          page: page || 0,
          pageSize: limit || defaultLimit,
        },
        onSuccess: ({ data }) => ({
          type: BULK_BUNDLE_SET_JOBS,
          payload: data,
        }),
      })
    );
  };

export const searchForBulkJobs =
  (query?: ISearchQuery) => (dispatch: Dispatch, getState: () => IState) => {
    const {
      config: { limit: defaultLimit },
    } = getState();
    const { page, limit, searchTerm } = query || {};
    if (!page) {
      dispatch(clearBulkBundleJobList());
    }
    dispatch(
      apiAction({
        url: endpoints.FETCH_BULK_BUNDLE_JOBS,
        method: EMethods.GET,
        label: BULK_BUNDLE_FETCH_JOBS,
        withStoreId: true,
        withToken: true,
        isBundlePromotion: true,
        data: {
          name: searchTerm,
          page: page || 0,
          pageSize: limit || defaultLimit,
        },
        onSuccess: ({ data }) => ({
          type: BULK_BUNDLE_SET_JOBS,
          payload: data,
        }),
      })
    );
  };

export const updateBulkBundleJobStatus =
  (id: string, status: string) =>
  (dispatch: Dispatch, getState: () => IState) => {
    const endpoint = replaceUrlVariables(
      endpoints.UPDATE_BULK_BUNDLE_JOB_STATUS,
      {
        id,
        status,
      }
    );
    dispatch(
      apiAction({
        url: endpoint,
        method: EMethods.PUT,
        label: BULK_BUNDLE_UPDATE_JOB_STATUS,
        withToken: true,
        withStoreId: true,
        isBundlePromotion: true,
        data: {},
        onSuccess: ({ data }) => ({
          type: BULK_BUNDLE_UPDATE_JOB_STATUS,
          payload: data,
        }),
      })
    );
  };

export const updateBulkBundlePageNumber = (pageNumber: number) => ({
  type: BULK_BUNDLE_UPDATE_PAGE_NUMBER,
  payload: pageNumber,
});
